<template>
  <div>
    <modalWindow v-model="showModel" @cancel="cancel()" @ok="confirm()" @closed="onClose()" title="Upozornenie" okText="Potvrdiť" cancelText="Zrušiť">
      <div class="row">
        <div class="col-md-12">
          {{ text }}
        </div>
      </div>
    </modalWindow>
  </div>
</template>

<script>
  import modal from 'vue-strap/src/Modal';

  export default {
    components: {modalWindow: modal},
    props: {
      showModel: {
        type: Boolean,
        default: false
      },
      text: {
        type: String
      },
    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
      onClose() {
        this.unprotect();
      },
      async confirm() {
        await this.protect();
        this.$emit('confirm');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/confirmationModal.vue